module.exports = __webpack_public_path__ + "img/flow.6a578063.png";